const API_URL="https://epu-index.pl";


export async function fetchEPU(
 source="poland",
 frequency="daily"
){

const response = await fetch(
`${API_URL}/api/epu?source=${source}&frequency=${frequency}`
);


if(!response.ok){
 throw new Error("Failed to fetch EPU data");
}


return await response.json();

}